module.exports = __webpack_public_path__ + "img/ico224.e7e247ed.svg";